import { Controller } from "@hotwired/stimulus"

const COLUMN_GAP = 40
const MIN_WIDTH = 160
const MAX_WIDTH = 240
const EDGE_GAP = 16
const CARD_SELECTOR = ".link-card[data-screenshot-preview]"

export default class extends Controller {
  connect() {
    // Turbo のキャッシュから復元された場合は、保存済みの要素を再利用する。
    this.preview = this.element.querySelector(":scope > img.link-preview") || document.createElement("img")
    this.preview.className = "link-preview"
    this.preview.alt = ""
    this.preview.hidden = true
    this.preview.addEventListener("load", this.place)
    this.element.append(this.preview)
    this.element.addEventListener("pointerover", this.showOnMouse)
    this.element.addEventListener("focusin", this.showOnKeyboardFocus)
    this.element.addEventListener("pointerout", this.hide)
    this.element.addEventListener("focusout", this.hide)
    window.addEventListener("resize", this.reset)
    document.addEventListener("turbo:before-cache", this.reset)
  }

  disconnect() {
    this.element.removeEventListener("pointerover", this.showOnMouse)
    this.element.removeEventListener("focusin", this.showOnKeyboardFocus)
    this.element.removeEventListener("pointerout", this.hide)
    this.element.removeEventListener("focusout", this.hide)
    window.removeEventListener("resize", this.reset)
    document.removeEventListener("turbo:before-cache", this.reset)
    this.preview.removeEventListener("load", this.place)
    this.preview.remove()
  }

  // タップで出すと、別タブから戻った後も次にどこかを触るまで表示が残る。
  showOnMouse = event => {
    if (event.pointerType === "mouse") this.show(event)
  }

  // クリックで付いたフォーカスは、別タブから戻ったときにも focusin を起こすので対象にしない。
  showOnKeyboardFocus = event => {
    if (event.target.matches(":focus-visible")) this.show(event)
  }

  show(event) {
    const card = event.target.closest(CARD_SELECTOR)
    if (!card || card === this.activeCard) return
    this.reset()
    if (this.columnWidth() < MIN_WIDTH) return
    this.activeCard = card
    this.preview.src = card.dataset.screenshotPreview
  }

  // Word のタブ切替などでカードが DOM から外れると、そのカードからは pointerout が来なくなる。
  hide = event => {
    if (!this.activeCard) return
    const leftCard = this.activeCard.contains(event.target) && !this.activeCard.contains(event.relatedTarget)
    if (leftCard || !this.activeCard.isConnected) this.reset()
  }

  reset = () => {
    this.activeCard = null
    this.preview.hidden = true
    this.preview.removeAttribute("src")
  }

  // 読み込み完了後に高さが決まるので、表示位置もそこで決める。
  place = () => {
    const bounds = this.element.getBoundingClientRect()
    this.preview.style.width = `${this.columnWidth()}px`
    this.preview.style.left = `${bounds.width + COLUMN_GAP}px`
    this.preview.hidden = false
    const height = this.preview.getBoundingClientRect().height
    const cardTop = this.activeCard.getBoundingClientRect().top
    const viewportTop = Math.max(EDGE_GAP, Math.min(cardTop, window.innerHeight - EDGE_GAP - height))
    this.preview.style.top = `${viewportTop - bounds.top}px`
  }

  columnWidth() {
    const right = this.element.getBoundingClientRect().right
    return Math.min(MAX_WIDTH, document.documentElement.clientWidth - right - COLUMN_GAP - EDGE_GAP)
  }
}
